import { useAuth } from 'src/contexts/AuthContext';
import { useWalletAuth } from './useWalletAuth';

export const useSelectedAddress = () => {
  const { address } = useWalletAuth();
  const { userData } = useAuth();
  const addresses = userData?.addresses;
  const addressFormatted = address?.toString().toLowerCase();

  const isConnectedAddress =
    !!addresses && addressFormatted && addresses.includes(addressFormatted);
  const selectedAddress = isConnectedAddress ? addressFormatted : 'connect';

  return { selectedAddress, isConnectedAddress, addressFormatted };
};
